import { createRouter as _createRouter, createWebHistory } from 'vue-router'

import admin from './admin.js'
import auth from './auth.js'
import dash from './dash.js'
import errors from './errors.js'
import onboarding from './onboarding.js'
import print from './print.js'
import publicRoutes from './public.js'

function createRouter() {
  return _createRouter({
    history: createWebHistory(),
    scrollBehavior() {
      // always scroll to top
      return { top: 0 }
    },
    linkActiveClass: 'active',
    routes: [...admin, ...auth, ...onboarding, ...dash, ...print, ...publicRoutes, ...errors],
  })
}

export const router = createRouter()
